define('score_bootstrap/Models/Liking/PageLikingModel',[],function () {
    "use strict";

    function PageLikingModel() {

        var instance = {
                userName: '',
                dateLiked: null
            };

        Object.defineProperties(this, {

            userName: {
                enumerable: true,
                get: function () { return instance.userName; },
                set: function (value) {
                    if (value) {
                        instance.userName = String(value);
                    }
                }
            },

            isLiked: {
                enumerable: true,
                get: function () { return instance.isLiked; },
                set: function (value) {
                    if (value) {
                        instance.isLiked = true;
                    } else {
                        instance.isLiked = false;
                    }
                }
            },

            pageId: {
                enumerable: true,
                get: function () { return instance.pageId; },
                set: function (value) {
                    if (value) {
                        instance.pageId = String(value);
                    }
                }
            },

            siteName: {
                enumerable: true,
                get: function () { return instance.siteName; },
                set: function (value) {
                    if (value) {
                        instance.siteName = String(value);
                    }
                }
            },

            pageVersion: {
                enumerable: true,
                get: function () { return instance.pageVersion; },
                set: function (value) {
                    if (value) {
                        instance.pageVersion = String(value);
                    }
                }
            },

            uniqueId: {
                enumerable: true,
                get: function () { return instance.uniqueId; },
                set: function (value) {
                    if (value) {
                        instance.uniqueId = String(value);
                    }
                }
            },

            language: {
                enumerable: true,
                get: function () { return instance.language; },
                set: function (value) {
                    if (value) {
                        instance.language = String(value);
                    }
                }
            },
            
            dateLiked: {
                enumerable: true,
                get: function () { return instance.dateLiked; },
                set: function (value) {
                    if (value) {
                        instance.dateLiked = Date(value);
                    } else {
                        instance.dateLiked = null;
                    }
                    
                }
            },

            isInProgress: {
                enumerable: true,
                get: function () { return instance.isInProgress; },
                set: function (value) {
                    if (value) {
                        instance.isInProgress = true;
                    } else {
                        instance.isInProgress = false;
                    }
                }
            }
        });
    }

    return PageLikingModel;
});
